export { default as DraftModeDepartmentsSection } from './DraftModeDepartmentsSection.client';
export { default as DepartmentsSection } from './DepartmentsSection';
